/**
 * Convert date from various formats to YYYY-MM-DD for HTML5 date input
 * @param dateString - The input date string in various formats
 * @returns The formatted date string in YYYY-MM-DD format for HTML5 date input
 */
export const formatDateForInput = (dateString: string): string => {
  if (!dateString) return '';

  // If already in YYYY-MM-DD format, return as is
  if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateString;
  }

  // If in YYYYMMDD format, convert to YYYY-MM-DD
  if (dateString.length === 8 && dateString.match(/^\d{8}$/)) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  return '';
};
